<div class="tag-list">
  <ng-content></ng-content>
</div>
